// components/DirectorMessage.jsx
import React from "react";
import {
  FaQuoteLeft,
  FaGraduationCap,
  FaLightbulb,
  FaUniversity,
} from "react-icons/fa";

const DirectorMessage = () => {
  return (
    <section className="relative py-20 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-white to-red-50 overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-orange-300/20 rounded-full blur-3xl -translate-x-20"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-red-300/20 rounded-full blur-3xl translate-x-20"></div>

      <div className="relative max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-12">
          <span className="inline-block px-5 py-2 text-sm font-semibold text-red-600 bg-red-100 rounded-full mb-4">
            Director’s Message
          </span>

          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900">
            From the{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Director’s Desk
            </span>
          </h2>

          <p className="text-gray-600 mt-4 max-w-2xl mx-auto leading-7">
            Inspiring young minds through values, wisdom and modern education.
          </p>
        </div>

        {/* Main Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          {/* Left Side */}
          <div className="bg-gradient-to-br from-red-600 to-orange-500 rounded-[32px] p-7 md:p-10 text-white shadow-2xl flex flex-col justify-between">
            <div>
              <div className="w-16 h-16 rounded-2xl bg-white/15 flex items-center justify-center text-2xl mb-6">
                <FaQuoteLeft />
              </div>

              <h3 className="text-3xl md:text-4xl font-extrabold leading-tight mb-6">
                Education Builds
                <br />
                Future Citizens
              </h3>

              <p className="text-white/90 leading-8 text-sm md:text-base">
                Education is not only about books, but about awakening the
                inner power of body, mind, heart and spirit. A balanced child
                becomes a responsible citizen and future leader.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
              <div className="bg-white/15 rounded-2xl p-4 border border-white/20">
                <FaGraduationCap className="text-xl mb-3 text-yellow-200" />
                <h4 className="font-bold text-sm">Holistic Growth</h4>
                <p className="text-xs text-white/80 mt-1">
                  Body, mind, heart and spirit development.
                </p>
              </div>

              <div className="bg-white/15 rounded-2xl p-4 border border-white/20">
                <FaLightbulb className="text-xl mb-3 text-yellow-200" />
                <h4 className="font-bold text-sm">Modern Thinking</h4>
                <p className="text-xs text-white/80 mt-1">
                  Science, logic and innovation based learning.
                </p>
              </div>

              <div className="bg-white/15 rounded-2xl p-4 border border-white/20 sm:col-span-2">
                <FaUniversity className="text-xl mb-3 text-yellow-200" />
                <h4 className="font-bold text-sm">Indian Values</h4>
                <p className="text-xs text-white/80 mt-1">
                  Inspired by Nalanda & Takshila with rich traditions.
                </p>
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="bg-white rounded-[32px] shadow-2xl border border-orange-100 p-7 md:p-10 flex flex-col justify-between">
            <div>
              <span className="inline-block px-4 py-1.5 text-xs font-semibold text-red-600 bg-red-100 rounded-full mb-4">
                Message
              </span>

              <h3 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-5 leading-tight">
                Proper Blend of{" "}
                <span className="text-red-600">
                  Modern Education & Values
                </span>
              </h3>

              <p className="text-gray-600 text-sm md:text-[15px] leading-8 text-justify mb-4">
                Education is a very wide term that includes every aspect of
                life. A child starts learning from the lap of the mother, even
                before understanding language.
              </p>

              <p className="text-gray-600 text-sm md:text-[15px] leading-8 text-justify mb-4">
                Education does not mean cramming books without understanding
                logic. In this modern era, we need an education system that
                develops both inner and outer strength of every child.
              </p>

              <p className="text-gray-600 text-sm md:text-[15px] leading-8 text-justify">
                Therefore, our school provides a proper blend of modern
                education with traditional values. Our aim is the overall
                development of each child to excel in this competitive world.
              </p>
            </div>

            {/* Signature */}
            <div className="mt-8 pt-6 border-t border-gray-100">
              <h4 className="text-xl font-bold text-gray-900">
                Prof. J.P. Lal
              </h4>
              <p className="text-sm text-red-600 font-semibold mt-1">
                Honorary Director
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DirectorMessage;